<template>
  <div class="mb-3">
    <Alert
      type="alert-info"
      text="In this section you can link chats to be invoked when Inline button is clicked.
      You will see Inline buttons here, once you create them in chat."
    ></Alert>
    <AlertLink link="/user-guide#InlineButton" text="Read more about Inline buttons here"></AlertLink>

    <div class="mb-3" v-for="(action,index) in callbacks" :key="index">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">{{action.button.text}}</span>
        </div>
        <input
          class="form-control"
          type="text"
          v-model="action.button.callback_data"
          placeholder="callback data"
          readonly
        />
        <select class="form-control" v-model="action.chat">
          <option :value="null">Select chat</option>
          <option
            v-for="(chat_name, index) in chat_names"
            :value="chat_name"
            :key="index"
          >{{chat_name}}</option>
        </select>
        <div class="input-group-append">
          <span class="input-group-text">
            <input type="checkbox" class="form-check-input" v-model="action.prime" />Prime
          </span>
      </div>
      </div>
    </div>
  </div>
</template>



<script>
import Alert from "@/components/Alert.vue";
import AlertLink from "@/components/AlertLink.vue";

export default {
  name: "Callbacks",
  components: {
    Alert,
    AlertLink,
  },
  props: {
    callbacks: Array,
    chat_names: Array,
  },
};
</script>
